import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    height: 80,
    position: 'fixed',
    top: 0,
    zIndex: 100,
    backgroundColor: 'transparent',
    width: '100%',
    transition: 'all 0.3s',
  },
  scrolled: {
    backgroundColor: theme.palette.colors.white,
    boxShadow: `0px 4px 6px #F1F4F8`,
    transition: 'all 0.2s',
  },
  content: {
    margin: [0, 'auto'],
    padding: [0, 40],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',

    [theme.breakpoints.up('lg')]: {
      padding: [0, 70],
      maxWidth: 1690,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Header/components/DesktopHeader/useStyles.js